<template>
  <div class="components-event-reservation-form">
    <div class="columns">
      <div class="column is-12 is-offset-0 is-10-widescreen is-offset-1-widescreen is-8-fullhd is-offset-2-fullhd">
        <div class="box has-background-white-bis has-text-centered" v-if="finished">
          <p class="is-size-5">
            {{ $t('reservation.statuses.new.notice')}}.
          </p>
        </div>
        <div class="box has-background-white-bis" v-else>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label" :class="'has-text-' + secondaryColor">{{ $t('reservation.name') }} <span class="has-text-danger">*</span></label>
                <div class="control has-icons-left">
                  <input
                      :class="{'is-danger': nameError}"
                      class="input"
                      type="text"
                      v-model="nameValue"
                  />
                  <span class="icon is-small is-left"><i class="fas fa-user"></i></span>
                </div>
                <p class="help is-danger" v-if="nameError">{{ nameError }}</p>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label" :class="'has-text-' + secondaryColor">E-mail <span class="has-text-danger">*</span></label>
                <div class="control has-icons-left">
                  <input
                      :class="{'is-danger': emailError}"
                      class="input"
                      type="text"
                      v-model="emailValue"
                  />
                  <span class="icon is-small is-left"><i class="fas fa-at"></i></span>
                </div>
                <p class="help is-danger" v-if="emailError">{{ emailError }}</p>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label" :class="'has-text-' + secondaryColor">{{ $t('reservation.phone') }}</label>
                <div class="control has-icons-left">
                  <input
                      :class="{'is-danger': phoneError}"
                      class="input"
                      type="text"
                      v-model="phoneValue"
                  />
                  <span class="icon is-small is-left"><i class="fas fa-phone"></i></span>
                </div>
                <p class="help is-danger" v-if="phoneError">{{ phoneError }}</p>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label" :class="'has-text-' + secondaryColor">{{ $t('vue.message') }}</label>
                <div class="control">
                  <textarea
                      :class="{'is-danger': noteError}"
                      class="textarea"
                      rows="2"
                      v-model="noteValue"
                  />
                </div>
                <p class="help is-danger" v-if="noteError">{{ noteError }}</p>
              </div>
            </div>
          </div>
          <label class="checkbox">
            <input type="checkbox" v-model="newsletterValue" />
            {{ $t('vue.newsletter') }}
          </label>
          <div class="has-text-centered pt-5">
            <a class="button is-warning" @click="send">{{ $t('vue.sendReservation') }}</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    locale: String,
    createUrl: String,
    secondaryColor: String
  },

  data() {
    return {
      nameValue: null,
      emailValue: null,
      phoneValue: null,
      noteValue: null,

      loading: false,
      finished: false,

      nameError: null,
      emailError: null,
      phoneError: null,
      noteError: null,

      newsletterValue: false,
    }
  },
  methods: {
    clearErrors() {
      this.nameError = null;
      this.emailError = null;
      this.phoneError = null;
      this.noteError = null;
    },
    send() {
      if (!this.loading) {
        this.loading = true;
        this.clearErrors();
        let data = {
          name: this.nameValue,
          email: this.emailValue,
          phone: this.phoneValue,
          note: this.noteValue,
          newsletter: this.newsletterValue,
        };

        axios.post(this.createUrl, data).then(() => {
          this.finished = true;
          this.loading = false;
          this.nameValue = null;
          this.emailValue = null;
          this.phoneValue = null;
          this.noteValue = null;
          this.newsletterValue = false;
        }).catch((error) => {
          let errors = error.response.data.errors;
          this.nameError = errors.name ? errors.name[0] : null;
          this.emailError = errors.email ? errors.email[0] : null;
          this.phoneError = errors.phone ? errors.phone[0] : null;
          this.noteError = errors.note ? errors.note[0] : null;
          this.loading = false;
        });
      }
    },
  },
  mounted() {
  }
}
</script>
